export const mainCategories = [
  {
    id: 'rengoring',
    title: 'Rengøring',
    description: 'Vi tilbyder alt fra erhvervs- og privatrengøring til specialopgaver som sommerhusrengøring og håndværkerrengøring.',
    image: '/images/rent-hjem.jpg',
    href: '/services'
  },
  {
    id: 'maler',
    title: 'Malerservice',
    description: 'Professionelt malerarbejde udført med sans for detaljen. Vi klarer alt fra vægge og lofter til træværk og facader.',
    image: 'https://assets.auxodev.dk/assets/09a255bd-240d-4146-9576-7ce8e0751aeb/7bf6af18-8791-4521-90ba-6c12e1690586.jpg',
    href: '/malerservice'
  }
];

export const services = [
  {
    id: 'erhverv',
    title: 'Erhvervsrengøring',
    description: 'Professionel rengøring tilpasset jeres virksomheds behov. Vi sikrer et sundt og præsentabelt arbejdsmiljø.',
    image: '/erhverv.jpg'
  },
  {
    id: 'privat',
    title: 'Privat rengøring',
    description: 'Giv dig selv mere tid i hverdagen. Vi leverer grundig og diskret rengøring i dit private hjem.',
    image: '/privat.jpg'
  },
  {
    id: 'sommerhus',
    title: 'Sommerhusrengøring',
    description: 'Klargøring af ferieboligen til udlejning eller eget brug. Vi sørger for, at alt står skarpt til de næste gæster.',
    image: '/images/dansk-sommerhus.jpg'
  },
  {
    id: 'haandvaerker',
    title: 'Håndværkerrengøring',
    description: 'Grundig rengøring efter nybyg eller renovering. Vi fjerner byggestøv og sikrer, at boligen er klar til indflytning.',
    image: 'https://assets.auxodev.dk/assets/09a255bd-240d-4146-9576-7ce8e0751aeb/8b8ca64c-7b7d-45df-a123-6f6fda4da4f6.png'
  },
  {
    id: 'fliserens',
    title: 'Fliserens',
    description: 'Vi tilbyder professionel rensning af fliser, der fjerner alger, flisepest og snavs. Efter behandlingen fremstår dine fliser som nye, og vi tilbyder også imprægnering for længere holdbarhed.',
    image: 'https://assets.auxodev.dk/assets/09a255bd-240d-4146-9576-7ce8e0751aeb/ef5d91ac-b115-4d46-935c-e31671dfce55.png'
  }
];

export const contactServices = [
  ...services,
  { id: 'maler', title: 'Malerservice' }
];

export const navigation = [
  { name: 'Forside', href: '/' },
  { name: 'Om os', href: '/om-os' },
  { name: 'Rengøring', href: '/services' },
  { name: 'Malerservice', href: '/malerservice' }
];
